/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

 document.addEventListener('variant:changed', function (event) {
  var variant = event.detail.variant; // Get the variant that was added
  var quantity = event.detail.quantity; // Get the quantity that was added
  //console.log(variant, quantity);
});

// Ajaxinate Lazy Load
//===========================================================================
var endlessScroll = null;

function initEndlessScroll() {
  if (endlessScroll) {
    // Ajaxinate.destroy() calls removeEventListener on its nextPageLinkElement,
    // which is undefined when the instance was created without a pagination link
    // (e.g. a transient re-render). That throw would otherwise abort this
    // function before the new instance is created, leaving the sorted/filtered
    // grid with no bound "Load More" - so the link navigates and the page fully
    // reloads. Swallow it so we always re-create below.
    try {
      if (endlessScroll.request) {
        endlessScroll.request.abort();
      }

      endlessScroll.destroy();
    } catch (err) {
      /* previous instance had nothing to unbind - safe to discard */
    }
  }

  endlessScroll = new Ajaxinate({
    method: 'click',
  });
}

document.addEventListener('DOMContentLoaded', initEndlessScroll);

// Sorting/filtering a collection re-renders the product grid via AJAX,
// detaching the nodes Ajaxinate is bound to - re-bind after each reload.
document.addEventListener('theme:loading:end', initEndlessScroll);

// "Load More" stays a manual click for the FIRST extra page. Once the shopper
// clicks it once, infinite scroll takes over: each further page loads as they
// scroll to the bottom (one page per scroll, no more clicks). A sort/filter
// re-render fires theme:loading:end, resetting to click-first.
(function () {
  var autoLoad = false;
  var loadingMore = false;
  var replaying = false;

  function paginationLink() {
    return document.querySelector('.AjaxinatePagination a');
  }

  // Resolve once the pending page has swapped in (pagination link changes or
  // disappears), so we never double-load or click the same link twice.
  function afterPageLoads(prevHref, done) {
    var checks = 0;
    var poll = window.setInterval(function () {
      checks += 1;
      var link = paginationLink();
      if (!link || link.getAttribute('href') !== prevHref || checks > 25) {
        window.clearInterval(poll);
        done();
      }
    }, 200);
  }

  // The first manual click turns infinite scroll on, but auto-loading is blocked
  // until that click's page has loaded, so the click yields exactly one page and
  // the next page waits for the shopper to scroll.
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('.AjaxinatePagination a');
    if (!link || replaying) { return; }

    // Ajaxinate intercepts the click via a listener bound to the specific link
    // element. After a sort/filter AJAX re-render that binding can be left on the
    // old (detached) link, so the new "Load More" link has nothing preventing its
    // default navigation - the page does a full reload. If Ajaxinate isn't holding
    // the link we actually clicked, re-bind to the live grid and replay the click
    // so it loads inline instead.
    if (!endlessScroll || endlessScroll.nextPageLinkElement !== link) {
      e.preventDefault();
      initEndlessScroll();
      if (endlessScroll && endlessScroll.nextPageLinkElement === link) {
        replaying = true;
        link.click();
        replaying = false;
      }
    }

    if (autoLoad) { return; }
    autoLoad = true;
    loadingMore = true;
    afterPageLoads(link.getAttribute('href'), function () { loadingMore = false; });
  });

  document.addEventListener('theme:loading:end', function () {
    autoLoad = false;
    loadingMore = false;
  });

  function maybeAutoLoad() {
    if (!autoLoad || loadingMore) { return; }
    var link = paginationLink();
    if (!link) { return; }
    if (link.getBoundingClientRect().top > window.innerHeight + 300) { return; }
    loadingMore = true;
    var prevHref = link.getAttribute('href');
    link.click();
    afterPageLoads(prevHref, function () { loadingMore = false; });
  }

  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) { return; }
    ticking = true;
    window.requestAnimationFrame(function () {
      ticking = false;
      maybeAutoLoad();
    });
  }, { passive: true });
})();

// RTW wedding landing: "Shop by product" / "Shop by theme" toggle the two grids
// in place (no navigation). Nudges lazysizes so a revealed grid loads its images.
//===========================================================================
(function () {
  if (!document.querySelector('[data-rtw-view]')) { return; }

  function showView(view) {
    document.querySelectorAll('[data-rtw-view]').forEach(function (tab) {
      var on = tab.getAttribute('data-rtw-view') === view;
      tab.classList.toggle('is-active', on);
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    document.querySelectorAll('[data-rtw-grid]').forEach(function (grid) {
      grid.classList.toggle('RtwGrid--hidden', grid.getAttribute('data-rtw-grid') !== view);
    });
    if (window.lazySizes && window.lazySizes.loader) {
      window.lazySizes.loader.checkElems();
    } else {
      window.dispatchEvent(new Event('scroll'));
    }
  }

  document.addEventListener('click', function (e) {
    var tab = e.target.closest && e.target.closest('[data-rtw-view]');
    if (tab) { e.preventDefault(); showView(tab.getAttribute('data-rtw-view')); }
  });
})();
